var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaycircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "play-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.429,
    height: 78.418,
    viewBox: "0 0 78.429 78.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_87650",
    "data-name": "Path 87650",
    d: "M31.951,21.972,15.666,10.134a1.964,1.964,0,0,0-3.119,1.584V35.387a1.958,1.958,0,0,0,1.073,1.751,1.978,1.978,0,0,0,.893.211,1.952,1.952,0,0,0,1.154-.381L31.951,25.14a1.948,1.948,0,0,0,0-3.168Z",
    transform: "translate(20.199 15.704)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87651",
    "data-name": "Path 87651",
    d: "M39.216,0A39.209,39.209,0,1,0,78.429,39.218,39.211,39.211,0,0,0,39.216,0Zm0,71.875a32.665,32.665,0,1,1,32.66-32.66A32.66,32.66,0,0,1,39.216,71.877Z",
    transform: "translate(0 -0.002)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaycircle);
export default __webpack_public_path__ + "static/media/play circle.b513b6af50d2693822bc17e5c9596bec.svg";
export { ForwardRef as ReactComponent };